import api from "./client";
export async function login(data) {
    const res = await api.post("/auth/login", data);
    return res.data;
}
export async function getMe() {
    const res = await api.get("/admin/me");
    return res.data;
}
export async function changePassword(currentPassword, newPassword) {
    const res = await api.post("/admin/change-password", { currentPassword, newPassword });
    return res.data;
}
